import { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import OktaError from '../OktaError';

const LoginCallback = ({ errorComponent, loadingElement = null, onAuthResume, ...props }) => {
  const { oktaAuth, authState } = useOktaAuth();
  const [callbackError, setCallbackError] = useState(null);

  useEffect(() => {
    if (onAuthResume && oktaAuth.isInteractionRequired && oktaAuth.isInteractionRequired()) {
      onAuthResume();
      return;
    }

    if (oktaAuth.isLoginRedirect()) {
      oktaAuth
        .handleLoginRedirect()
        .then(() => {
          // In `<Security>` component service was not started in case of login redirect.
          // Start it now after `restoreOriginalUri` has been called and route changed.
          oktaAuth.start();
        })
        .catch((e) => {
          setCallbackError(e);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oktaAuth]);

  const authError = authState && authState.error;
  const displayError = callbackError || authError;
  const ErrorReporter = errorComponent || OktaError;

  if (displayError) {
    return <ErrorReporter error={displayError} />;
  }

  return loadingElement;
};

export default LoginCallback;
